import React from 'react'
import {Link} from 'gatsby'

const MenuCompleto = ({english}) => {

    return (
        <ul className="navegacion">
            <li>
                <Link 
                    to={english? '/en#inicio' : '/#inicio'}
                >{english? 'HOME' : 'Inicio'}</Link>
            </li>
            <li>
                <Link 
                    href={english? '/en#plan-maestro' : '/#plan-maestro'}
                >{english? 'MASTER PLAN' : 'Plan maestro'}</Link> 
            </li>
            <li>
                <Link
                    href={english? '/en#proyectos' : '/#proyectos'}
                >{english? 'PROJECTS' : 'Proyectos'}</Link> 
            </li>
            <li>
                <Link 
                    href={english? '/en#ubicacion' : '/#ubicacion'}
                >{english? 'LOCATION' : 'Ubicación'}</Link> 
            </li>
            <li>
                <Link 
                    href={english ? '/en#contacto' : '/#contacto'}
                >{english? 'CONTACT' : 'Contacto'}</Link> 
            </li>
        </ul>
    )
}

export default MenuCompleto